import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/squYXr2q2Ac1B7GwC1hwfq/mda.png';
interface LogoProps {
  /** "light" = original-color mark for white/light backgrounds (header). "dark" = solid-white mark for the navy footer. */
  variant?: 'light' | 'dark';
  className?: string;
}
/**
 * Official MDA Production & Process Solutions logo.
 *
 * The mark is shown with `object-contain` so the FULL logo is always visible
 * with its original proportions (no cropping, no distortion).
 * - light: original navy + orange colors, for the white header.
 * - dark: rendered as a single-color WHITE logo (via `brightness-0 invert`)
 *   directly on the dark-blue footer — no white background plate.
 */
export function Logo({
  variant = 'light',
  className = ''
}: LogoProps) {
  if (variant === 'dark') {
    return <img src={LOGO_URL} alt="MDA Production & Process Solutions" className={`h-24 w-auto object-contain select-none [filter:brightness(0)_invert(1)] ${className}`} draggable={false} data-id="element-102" />;
  }
  return <img src={LOGO_URL} alt="MDA Production & Process Solutions" className={`h-20 w-auto object-contain select-none ${className}`} draggable={false} data-id="element-103" />;
}